export default __webpack_public_path__ + "static/media/card_back_blank.474e2d88.svg";